"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ariaHidden = void 0;
var utils_1 = require("@prezzee/utils");
// Is a vertical scrollbar displayed?
function isOverflowing(container) {
    var doc = (0, utils_1.ownerDocument)(container);
    if (doc.body === container) {
        return (0, utils_1.ownerWindow)(container).innerWidth > doc.documentElement.clientWidth;
    }
    return container.scrollHeight > container.clientHeight;
}
function ariaHidden(element, show) {
    if (show) {
        element.setAttribute('aria-hidden', 'true');
    }
    else {
        element.removeAttribute('aria-hidden');
    }
}
exports.ariaHidden = ariaHidden;
function getPaddingRight(element) {
    return parseInt((0, utils_1.ownerWindow)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    if (elementsToExclude === void 0) { elementsToExclude = []; }
    var blacklist = __spreadArray([mountElement, currentElement], __read(elementsToExclude), false);
    var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
    [].forEach.call(container.children, function (element) {
        if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) {
            ariaHidden(element, show);
        }
    });
}
function findIndexOf(items, callback) {
    var idx = -1;
    items.some(function (item, index) {
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function handleContainer(containerInfo, props) {
    var restoreStyle = [];
    var container = containerInfo.container;
    if (!props.disableScrollLock) {
        if (isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            var scrollbarSize_1 = (0, utils_1.getScrollbarSize)((0, utils_1.ownerDocument)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container,
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = "".concat(getPaddingRight(container) + scrollbarSize_1, "px");
            // .mui-fixed is a global helper.
            var fixedElements = (0, utils_1.ownerDocument)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, function (element) {
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element,
                });
                element.style.paddingRight = "".concat(getPaddingRight(element) + scrollbarSize_1, "px");
            });
        }
        // Improve Gatsby support
        // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
        var parent_1 = container.parentElement;
        var containerWindow = (0, utils_1.ownerWindow)(container);
        var scrollContainer = (parent_1 === null || parent_1 === void 0 ? void 0 : parent_1.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent_1).overflowY === 'scroll'
            ? parent_1
            : container;
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer,
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer,
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer,
        });
        scrollContainer.style.overflow = 'hidden';
    }
    var restore = function () {
        restoreStyle.forEach(function (_a) {
            var value = _a.value, el = _a.el, property = _a.property;
            if (value) {
                el.style.setProperty(property, value);
            }
            else {
                el.style.removeProperty(property);
            }
        });
    };
    return restore;
}
function getHiddenSiblings(container) {
    var hiddenSiblings = [];
    [].forEach.call(container.children, function (element) {
        if (element.getAttribute('aria-hidden') === 'true') {
            hiddenSiblings.push(element);
        }
    });
    return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
var ModalManager = /** @class */ (function () {
    function ModalManager() {
        this.modals = [];
        this.containers = [];
    }
    ModalManager.prototype.add = function (modal, container) {
        var modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) {
            return modalIndex;
        }
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) {
            ariaHidden(modal.modalRef, false);
        }
        var hiddenSiblings = getHiddenSiblings(container);
        ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        var containerIndex = findIndexOf(this.containers, function (item) { return item.container === container; });
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [modal],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings,
        });
        return modalIndex;
    };
    ModalManager.prototype.mount = function (modal, props) {
        var containerIndex = findIndexOf(this.containers, function (item) { return item.modals.indexOf(modal) !== -1; });
        var containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) {
            containerInfo.restore = handleContainer(containerInfo, props);
        }
    };
    ModalManager.prototype.remove = function (modal) {
        var modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) {
            return modalIndex;
        }
        var containerIndex = findIndexOf(this.containers, function (item) { return item.modals.indexOf(modal) !== -1; });
        var containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) {
                containerInfo.restore();
            }
            if (modal.modalRef) {
                // In case the modal wasn't in the DOM yet.
                ariaHidden(modal.modalRef, true);
            }
            ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        }
        else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) {
                ariaHidden(nextTop.modalRef, false);
            }
        }
        return modalIndex;
    };
    ModalManager.prototype.isTopModal = function (modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    };
    return ModalManager;
}());
exports.default = ModalManager;
//# sourceMappingURL=ModalManager.js.map